(function () {
  'use strict';
  if (window.eezyVatCartReady) return;
  window.eezyVatCartReady = true;
  let busy = false, activeRoot = null, retry = null;
  const rootOf = () => document.querySelector('[data-eezy-vat-cart]');
  const configOf = root => JSON.parse(root.querySelector('[data-eezy-vat-config]').textContent);
  const choiceOf = root => root.querySelector('[name="eezy-vat-choice"]:checked')?.value;
  function error(root, text) { const box=root.querySelector('[data-eezy-vat-error]');box.textContent=text;box.hidden=false;box.focus(); }
  function refresh(root) {
    if (!root) return;
    const choice=choiceOf(root), fields=root.querySelector('[data-eezy-vat-fields]');
    fields.hidden=choice!=='relief';fields.disabled=choice!=='relief';
    const representative=root.querySelector('[data-eezy-vat-representative]');
    const forSelf=root.querySelector('[data-eezy-vat-field="for_self"]').value==='true';
    representative.hidden=forSelf;representative.disabled=forSelf || choice!=='relief';
    const other=root.querySelector('[data-eezy-vat-other]');
    other.hidden=root.querySelector('[data-eezy-vat-field="category"]').value!=='other';
    other.disabled=other.hidden || choice!=='relief';
    for(const label of root.querySelectorAll('[data-eezy-vat-name-label],[data-eezy-vat-address-label]'))label.textContent=forSelf?label.dataset.self:label.dataset.other;
    root.querySelector('[data-eezy-vat-field="name"]').autocomplete=forSelf?'section-vat shipping name':'off';
    root.querySelector('[data-eezy-vat-error]').hidden=true;
    const config=configOf(root), estimate=root.querySelector('[data-eezy-vat-estimate]');
    estimate.hidden=true;
    if(!choice || config.currency!=='GBP' || config.country!=='GB')return;
    try {
      let total;
      if(choice==='relief') total=config.cart.items.reduce((sum,item)=>{
        const variant=config.products[String(item.product_id)].variants.find(v=>v.id===Number(item.variant_id||item.id));
        return sum+variant.price*item.quantity;
      },0);
      else { const displayed=document.querySelector('[data-ezl-cart-total]'); if(!displayed)return; root.querySelector('[data-eezy-vat-total]').textContent=displayed.dataset.standard; estimate.hidden=false; return; }
      root.querySelector('[data-eezy-vat-total]').textContent=new Intl.NumberFormat(config.locale,{style:'currency',currency:config.currency}).format(total/100);
      estimate.hidden=false;
    } catch (_) {}
  }
  const legacyCode = value => String(value || '').trim().toUpperCase() === 'VAT_RELIEF';
  function discountCodes(cart) {
    return [...new Set([
      ...(cart.discount_codes || []).map(d => d.code),
      ...(cart.cart_level_discount_applications || []).filter(d => d.type === 'discount_code').map(d => d.title),
      ...cart.items.flatMap(i => (i.discount_allocations || i.line_level_discount_allocations || []).filter(d => d.discount_application?.type === 'discount_code').map(d => d.discount_application.title))
    ].filter(Boolean))];
  }
  async function cleanLegacyDiscount(config, cart) {
    const codes=discountCodes(cart);
    if(!codes.some(legacyCode))return cart;
    const updated=await request(config.updateUrl,{discount:codes.filter(code=>!legacyCode(code)).join(',')});
    if(discountCodes(updated).some(legacyCode))throw new Error('save');
    return updated;
  }
  function initialize() {
    const root=rootOf();
    if(!root || root===activeRoot)return;
    activeRoot=root;refresh(root);
    const config=configOf(root);
    request(config.cartUrl).then(cart=>cleanLegacyDiscount(config,cart).then(updated=>{
      if(updated!==cart)window.location.reload();
    })).catch(()=>error(root,config.text.save));
  }
  async function request(url,body,extraHeaders={}) {
    const options={headers:{Accept:'application/json',...extraHeaders},signal:AbortSignal.timeout(25000)};
    if(body){options.method='POST';options.headers['Content-Type']='application/json';options.body=JSON.stringify(body);}
    const response=await fetch(url,options);
    const data=await response.json();
    if(!response.ok || data.status>=400){const e=new Error('save');e.serviceMessage=typeof data.error==='string'?data.error:null;throw e;}
    return data;
  }
  async function requestId(payload) {
    const digest=await crypto.subtle.digest('SHA-256',new TextEncoder().encode(JSON.stringify(payload)));
    const hash=Array.from(new Uint8Array(digest),b=>b.toString(16).padStart(2,'0')).join('');
    let saved=retry;
    try { saved=JSON.parse(sessionStorage.getItem('eezy-vat-request')) || retry; } catch (_) {}
    if(!saved || saved.hash!==hash || Date.now()-saved.created>86400000) saved={id:crypto.randomUUID(),hash,created:Date.now()};
    retry=saved;
    try {sessionStorage.setItem('eezy-vat-request',JSON.stringify(saved));}catch(_){}
    return saved.id;
  }
  async function checkout(root,button) {
    if(busy)return;
    const config=configOf(root),choice=choiceOf(root),core=window.EezyVatCore;
    if(!choice){error(root,config.text.choose);return;}
    if(choice==='relief' && config.country!=='GB'){error(root,config.text.country);return;}
    if(choice==='relief')for(const input of root.querySelector('[data-eezy-vat-fields]').querySelectorAll('input,select,textarea'))if(!input.disabled && !input.reportValidity())return;
    busy=true;button.disabled=true;button.setAttribute('aria-busy','true');root.querySelector('[data-eezy-vat-status]').textContent=config.text.saving;
    try {
      const cart=await cleanLegacyDiscount(config,await request(config.cartUrl));
      if(core.fingerprint(cart)!==core.fingerprint(config.cart))throw new Error('changed');
      if(choice==='relief') {
        const headers={apikey:config.publishableKey};
        const health=await request(config.serviceUrl,undefined,headers);
        if(!health.enabled){const e=new Error('save');e.serviceMessage='VAT relief checkout is not available online yet. Please call 020 8050 4849 and we will help with your order.';throw e;}
        const value=key=>root.querySelector('[data-eezy-vat-field="'+key+'"]').value.trim();
        const forSelf=value('for_self')==='true';
        const category=root.querySelector('[data-eezy-vat-field="category"]');
        const confirmed=root.querySelector('[data-eezy-vat-confirm]').checked;
        const declaration={for_self:forSelf,country_code:'GB',person_name:value('name'),declarant_name:forSelf?'':value('declarant_name'),relationship:forSelf?'':value('relationship'),address_line1:value('address_line1'),address_line2:'',city:value('city'),postcode:value('postcode'),email:value('email'),condition:category.value==='other'?value('note'):category.selectedOptions[0].textContent.trim(),signature:forSelf?value('name'):value('declarant_name'),confirm_disabled:confirmed,confirm_personal_use:confirmed,confirm_correct:confirmed,declaration_version:'EEZY-3'};
        const payload={lines:cart.items.map(i=>({variant_id:i.variant_id,quantity:i.quantity,properties:i.properties,selling_plan_allocation:i.selling_plan_allocation})),declaration};
        payload.request_id=await requestId(payload);
        const result=await request(config.serviceUrl,payload,headers);
        const destination=new URL(result.checkout_url);
        if(destination.protocol!=='https:' || !['bentechmed.myshopify.com','shop.eezychair.com','eezychair.com','www.eezychair.com'].includes(destination.hostname))throw new Error('save');
        window.location.assign(destination.href);
        return;
      }
      const plan=core.plan(cart,config.products,'standard');
      let updated=cart;
      if(plan.changed)updated=await request(config.updateUrl,{updates:plan.updates});
      if(!core.matches(updated,plan.desired))throw new Error('changed');
      const attributes={'Eezy VAT choice':'Standard','Eezy VAT name':'','Eezy VAT category':'','Eezy VAT note':'','Eezy VAT declaration':'','Eezy VAT version':'EEZY-2','Eezy VAT date':new Date().toISOString(),'Eezy VAT basket':core.fingerprint(updated)};
      const saved=await request(config.updateUrl,{attributes});
      if(!core.matches(saved,plan.desired) || saved.attributes?.['Eezy VAT basket']!==core.fingerprint(saved))throw new Error('changed');
      window.location.assign(config.checkoutUrl);
    } catch(e) {error(root,e.serviceMessage || config.text[e.message] || config.text.save);root.querySelector('[data-eezy-vat-status]').textContent='';}
    finally {busy=false;button.disabled=false;button.removeAttribute('aria-busy');}
  }
  document.addEventListener('change',event=>{
    const root=event.target.closest('[data-eezy-vat-cart]');if(!root)return;
    if(event.target.name==='eezy-vat-choice' && event.target.value==='standard'){
      root.querySelectorAll('[data-eezy-vat-field]').forEach(input=>{input.value=input.dataset.eezyVatField==='for_self'?'true':'';});
      root.querySelectorAll('[data-eezy-vat-confirm]').forEach(input=>{input.checked=false;});
    }
    if(event.target.name==='eezy-vat-choice' || ['for_self','category'].includes(event.target.dataset.eezyVatField))refresh(root);
  });
  document.addEventListener('click',event=>{const button=event.target.closest('button[name="checkout"]'),root=rootOf();if(!button||!root||!button.closest('#cart'))return;event.preventDefault();event.stopImmediatePropagation();checkout(root,button);},true);
  document.addEventListener('submit',event=>{const root=rootOf();if(!root||event.target.id!=='cart'||event.submitter?.name!=='checkout')return;event.preventDefault();event.stopImmediatePropagation();checkout(root,event.submitter);},true);
  initialize();new MutationObserver(initialize).observe(document.getElementById('main-content')||document.body,{childList:true,subtree:true});
})();

